/**
 * The "Agendar demo" booking page (MAR-1164): the ONE place this URL is written down.
 *
 * `nuxt.config.ts` uses it as the default for `runtimeConfig.public.demoBookingUrl`
 * (`NUXT_PUBLIC_DEMO_BOOKING_URL` overrides it; Terraform sets nothing, so this IS the deployed
 * value), and components fall back to it when runtime config is unavailable (isolated unit tests).
 * `tests/unit/demoBookingUrl.test.ts` fails if a copy of a booking URL appears anywhere else.
 */
export const DEMO_BOOKING_URL = 'https://calendar.app.google/a6cDZCxSwSdfMkUY6'
